
export { GGUSection } from "/codebuild/output/src594262572/src/packages/shared-components/src/campaign/GGUSection.tsx"